

const EventBus = {
  install(Vue) {
    const eventBus = new Vue();
    Object.defineProperty(Vue.prototype, '$eventBus', {
      get: () => eventBus,
      set: (evt) => {
        const event = typeof evt === 'string' ? [evt] : evt;
        eventBus.$emit(event);
      },
    });

    Vue.mixin({
      created() {
        const { $eventBus } = this.$options;
        this.$busListeners = {};
        if ($eventBus) {
          const keys = Object.keys($eventBus);
          for (let i = 0; i < keys.length; i += 1) {
            const name = keys[i];
            this.$busListeners[name] = $eventBus[name].bind(this);
            eventBus.$on(name, this.$busListeners[name]);
          }
        }
      },

      beforeDestroy() {
        if (this.$busListeners) {
          const keys = Object.keys(this.$busListeners);
          for (let i = 0; i < keys.length; i += 1) {
            const name = keys[i];
            eventBus.$off(name, this.$busListeners[name]);
          }
          this.$busListeners = null;
        }
      },
    });
  },
};

export default EventBus;
